import { type DatiTitolare } from '@framework/api-client/api/inquiries-compile/schemas/datiTitolare.ts';
import { type IEngineValidatorContextUser } from '../../engine-validation/IEngineValidationContext.ts';
import { type ISessionDataUserReferences } from '../session/ISessionData.ts';

/**
 * Ritorna i campi del titolare o del richiedente. Utilizzato per le ref di tipo "Titolare o Utente Attivo: <...>",
 * viene valorizzato con i dati del titolare, se presente, altrimenti sono i dati del richiedente.
 */
export function mapApplicantOrUserToContext(
  user: IEngineValidatorContextUser | null | undefined,
  applicant: DatiTitolare | null | undefined,
): ISessionDataUserReferences {
  if (!applicant?.codiceFiscale) {
    return {
      nome: user?.nome,
      cognome: user?.cognome,
      email: user?.email,
      codice_fiscale: user?.codiceFiscale,
    };
  }
  return {
    nome: applicant?.nome,
    cognome: applicant?.cognome,
    email: applicant?.email,
    codice_fiscale: applicant?.codiceFiscale,
  };
}
